// extracted by mini-css-extract-plugin
module.exports = {"main":"NavBar_main__287kE","menu":"NavBar_menu__ZySjj"};